import { Option } from "../models/option.model";
import moment from "moment/moment";
import { UsStates } from "./us-states";

export abstract class FilterOptions {
  public static stateFilterOptions: Option[] = [
    { field: null, displayName: "All States" },
    ...UsStates.states
  ];

  public static dateFilterOptions: Option[] = [
    { field: "24hours", displayName: "Last 24 Hours" },
    { field: "48hours", displayName: "Last 48 Hours" },
    { field: "72hours", displayName: "Last 72 Hours" },
    { field: "7days", displayName: "Last 7 Days" },
    { field: "30days", displayName: "Last 30 Days" }
  ];

  public static getStateFilterOption(stateCode: string | null) {
    for (let option of this.stateFilterOptions) {
      if (option.field === stateCode) {
        return option;
      }
    }
    return null;
  }

  public static getDateFilterOption(dateCode: string | null) {
    for (let option of this.dateFilterOptions) {
      if (option.field === dateCode) {
        return option;
      }
    }
    return null;
  }

  public static buildFilters(
    columnName: string,
    option: Option | null,
    filters: { [key: string]: string } = {}
  ) {
    if (columnName === "addDate" && option != null) {
      if (option.field === "24hours") {
        filters["start"] = moment().subtract(24, "hours").format("MM/DD/YYYY HH:mm:ss.SSS");
      } else if (option.field === "48hours") {
        filters["start"] = moment().subtract(48, "hours").format("MM/DD/YYYY HH:mm:ss.SSS");
      } else if (option.field === "72hours") {
        filters["start"] = moment().subtract(72, "hours").format("MM/DD/YYYY HH:mm:ss.SSS");
      } else if (option.field === "7days") {
        filters["start"] = moment().subtract(7, "days").format("MM/DD/YYYY HH:mm:ss.SSS");
      } else if (option.field === "30days") {
        filters["start"] = moment().subtract(30, "days").format("MM/DD/YYYY HH:mm:ss.SSS");
      }
    }
    if (columnName == "state") {
      if (option == null || option.field == null) {
        delete filters["state"];
      } else {
        filters["state"] = option.field;
      }
    }

    return filters;
  }
}
